import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

interface AuthCarouselSlide {
    src: string;
    alt: string;
}

const SLIDE_INTERVAL_MS = 6000;

const SLIDES: AuthCarouselSlide[] = [
    { src: '/img/auth/slide-1-source-smarter.png', alt: 'Source smarter. Grow stronger. Connecting verified suppliers with professional resellers across the UAE and beyond.' },
    { src: '/img/auth/slide-2-discover-ideas.png', alt: 'Discover better ideas. Explore thousands of premium products from verified suppliers.' },
    { src: '/img/auth/slide-3-heart-of-opportunity.png', alt: 'Source in the heart of opportunity. Your gateway to the UAE and global markets.' },
    { src: '/img/auth/slide-4-stock-when-needed.png', alt: 'Stock when you need it. Source faster with suppliers holding stock in the UAE.' },
    { src: '/img/auth/slide-5-sustainable-choice.png', alt: 'A smarter, more sustainable choice. Discover eco-conscious products for a responsible future.' },
    { src: '/img/auth/slide-6-build-partnerships.png', alt: 'Build stronger partnerships. Work with trusted suppliers. Source with confidence.' },
];

@Component({
    selector: 'app-auth-layout',
    standalone: true,
    imports: [CommonModule, RouterOutlet],
    templateUrl: './auth-layout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLayoutComponent implements OnInit {
    private readonly _destroyRef = inject(DestroyRef);
    private _timer?: ReturnType<typeof setInterval>;

    readonly slides = SLIDES;
    readonly slideIntervalMs = SLIDE_INTERVAL_MS;
    readonly activeIndex = signal(0);

    ngOnInit(): void {
        this._restartTimer();
        this._destroyRef.onDestroy(() => clearInterval(this._timer));
    }

    selectSlide(index: number): void {
        this.activeIndex.set(index);
        this._restartTimer();
    }

    private _restartTimer(): void {
        clearInterval(this._timer);
        this._timer = setInterval(
            () => this.activeIndex.update((i) => (i + 1) % this.slides.length),
            this.slideIntervalMs,
        );
    }
}
